import { ParsleyJsFormEvent } from './enums/parsleyjs-form-event.enum';

declare var Parsley: { on: (eventName: string, callback: () => void) => void; };

const submitButtonSelector = 'button[type="submit"]';
const buttonsLoadingCssClass = 'jbr-btn--loading';

/**
 * Overrides ParsleyJS standard behaviour,
 */
export function overrideParsleyJS() {
  Parsley?.on(ParsleyJsFormEvent.Validate, function() {
    this.$element
      .find(submitButtonSelector)
      .prop('disabled', true);
  });

  Parsley?.on(ParsleyJsFormEvent.Error, function() {
    this.$element
      .find(submitButtonSelector)
      .prop('disabled', false)
      .removeClass(buttonsLoadingCssClass);
  });

  Parsley?.on(ParsleyJsFormEvent.Success, function() {
    this.$element
      .find(submitButtonSelector)
      .addClass(buttonsLoadingCssClass);
  });
}
